import { ResponseDataGet } from "../../../../models/responseDataGet";
import { agroApi } from "../../api";
import { Paths } from "../../../../paths";
import { EntInitialFilter } from "../../../../models/filters/initialFilter";
import { EntBasicHB } from "../../../../models/handBooks/basicHB";

export const industryTypeApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getIndustryTypeList: builder.query<ResponseDataGet<EntBasicHB>, EntInitialFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.industryType }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getIndustryTypeById: builder.query<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.industryType }/${ id }`,
		method: 'GET',
	  }),
	}),

	addIndustryType: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.industryType }`,
		method: "POST",
		body: JSON.stringify(body),
	  }),
	}),

	editIndustryType: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.industryType }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteIndustryType: builder.mutation<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.industryType }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useGetIndustryTypeListQuery,
  useGetIndustryTypeByIdQuery,
  useAddIndustryTypeMutation,
  useEditIndustryTypeMutation,
  useDeleteIndustryTypeMutation,
  useLazyGetIndustryTypeListQuery
} = industryTypeApi;
